// @flow
import React, { type Node } from 'react';
import { getWeekDay } from '@tectonics/prs/week-day';
import {
  getSafeDueDate,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { DisplayDueDate } from '../../../organisms/display-due-date';
import { DisplayTotalAmount } from '../../../organisms/display-total-amount';
import {
  PaymentInfoWrapper,
} from '../../../organisms/shared-styled-components';

export function RenderTotalAndDueDate(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <>
      <PaymentInfoWrapper>
        <DisplayTotalAmount label="Amount to Pay" location="left" redesign={true} />
        <DisplayDueDate label="Due Date" sublabel={`Pay by ${getWeekDay(getSafeDueDate(incomingPayment), dueDateWeekDay)}`} redesign={true} />
      </PaymentInfoWrapper>

    </>
  );
}

const dueDateWeekDay = [
  'Monday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Monday',
];
